import {
    type UtmCampaign,
    type UtmCampaignReserveTabEnum,
} from '@clients/ContentApi';
import { type BlurryImage } from '@store/content/entities/types';
import { toAbsoluteSrc } from '@store/content';

export default class SiteUtmCampaign {
    constructor(data: UtmCampaign) {
        this.id = data.id;
        this.title = data.Title;
        this.image = data.Image
            ? {
                  src: toAbsoluteSrc(data.Image.url),
                  blurHash: data.Image.blurhash,
              }
            : undefined;
        this.videoUrl = data.VideoUrl;
        this.couponCode = data.CouponCode;
        this.detailsUrl = data.DetailsUrl;
        this.closeTitle = data.CloseTitle;
        this.identifier = data.Identifier;
        this.reserveTab = data.reserveTab;
    }

    id: string;
    title: string;
    image?: BlurryImage;
    videoUrl?: string;
    couponCode?: string;
    detailsUrl?: string;
    closeTitle?: string;
    identifier: string;
    reserveTab?: UtmCampaignReserveTabEnum;
}
